import React, { useState, useRef, useEffect } from "react";
import "./loading.scss";
const Loading = function (props) {
  const times = useRef(null);
  const [cont, setCont] = useState(COMMON_LOADDING_CONT);
  useEffect(() => {
    times.current = setInterval(() => {
      if (COMMON_LOADDING_CONT > 78) {
        clearInterval(times.current);
      }
      COMMON_LOADDING_CONT += 2;
      setCont(COMMON_LOADDING_CONT);
    }, 60);
    return () => {
      clearInterval(times.current);
      times.current = null;
    };
  }, []);

  function isOpenDomain() {
    if (location.host.indexOf('pai-tech') !== -1) {
      return true
    } else {
      return false;
    }
  }

  // console.log('object :>> ', props.error);

  if (props.error) {
    return (
      <div className="default-wrapper">
        <img width="92" src={require("../static/images/offline.png")} alt="" />
        <p
          style={{
            fontSize: 14,
            color: "#999999",
            fontWeight: 500,
            marginTop: 12,
            marginBottom: 12,
          }}
        >
          加载异常!
        </p>
        <div className="btn" onClick={props.retry}>
          重新加载
        </div>
      </div>
    );
  } else if (props.timedOut) {
    return (
      <div className="default-wrapper">
        <img width="92" src={require("../static/images/offline.png")} alt="" />
        <p
          style={{
            fontSize: 14,
            color: "#999999",
            fontWeight: 500,
            marginTop: 12,
            marginBottom: 12,
          }}
        >
          页面超时了...
        </p>
        <div className="btn" onClick={props.retry}>
          重新加载
        </div>
      </div>
    );
  } else if (props.pastDelay) {
    return (
      // <div className="loading">
      //   <img src={require("../static/images/loading.gif")} alt="" />
      // </div>
      <div className="loadingBg">
        <div className="loadingContent">
          <div
            className="loadingLogo"
            style={!isOpenDomain() ? { opacity: 1 } : { opacity: 0 }}
          ></div>
          <div className="loadingLineBox">
            <div className="loadingLine" style={{ width: `${cont}%` }}></div>
          </div>
          <div className="loadingText">加载中 {cont}%</div>
        </div>
        <div className="loaddingFooterBottom">派生万物开放平台技术支持</div>
      </div>
    );
  } else {
    return null;
  }
};
export default Loading;
